import { render, staticRenderFns } from "./ItemSelectionModule.vue?vue&type=template&id=329681c5&scoped=true"
import script from "./ItemSelectionModule.vue?vue&type=script&lang=js"
export * from "./ItemSelectionModule.vue?vue&type=script&lang=js"
import style0 from "./ItemSelectionModule.vue?vue&type=style&index=0&id=329681c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329681c5",
  null
  
)

export default component.exports